import "ngstorage";
class TransfersController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    SecurityService,
    CompaniesService,
    $timeout,
    $rootScope,
    EnvService,
    ngProgressFactory,
    $scope,
    $location
  ) {
    this.name = "transfers";
    $localStorage.activeStateName = "transfers";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$progress = ngProgressFactory.createInstance();
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.currentUser = this.$auth.getUserData();
    this.currentUser.company.posting_types = [
      {id: 1, name: "On-Demand"},
      {id: 2, name: "Delivery"},
      {id: 3, name: "Pay For Post"},
    ];
    this.check_posting_settings(this.currentUser.company.postingTypesAllowed);
  }
}

TransfersController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "security",
  "companies",
  "$timeout",
  "$rootScope",
  "env",
  "ngProgressFactory",
  "$scope",
  "$location",
];

export default TransfersController;



// WEBPACK FOOTER //
// ./client/app/components/accountprofile/transfers/transfers.controller.js